import React from 'react';
import styles from './TooltipContent.module.scss';

const TooltipContent = ({ requestId, workerName, interval, address }) => {
  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <p className={styles.content}>{requestId}</p>
        <p className={styles.content}>{interval}</p>
      </div>
      <div className={styles.root}>
        <p className={styles.content}>
          <span style={{ fontWeight: 700 }}>Исполнитель: </span>
          {workerName}
        </p>
        <p
          className={styles.content}
          style={{
            display: 'flex',
            gap: '5px',
            justifyContent: 'space-between',
          }}
        >
          <span style={{ fontWeight: 700 }}>Адрес: </span>
          <span>{address}</span>
        </p>
      </div>
    </div>
  );
};

export default TooltipContent;
